export default "\n  <app-home-header></app-home-header>\n  <app-home-content></app-home-content>\n\n\n\n"